import { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import { allProjects, allIndustries } from '../../data/allProjects';

export function WorkHero() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let ctx: gsap.Context;

    const timer = setTimeout(() => {
      ctx = gsap.context(() => {
        gsap.fromTo(
          '.hero-animate',
          { y: 40, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 0.8,
            stagger: 0.1,
            ease: 'power2.out',
          }
        );
      }, sectionRef);
    }, 150);

    return () => {
      clearTimeout(timer);
      if (ctx) ctx.revert();
    };
  }, []);

  return (
    <section ref={sectionRef} className="relative pt-32 pb-16 px-8 md:px-12 lg:px-24">
      {/* Background gradient */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-0 w-[600px] h-[600px] bg-emerald-500/5 rounded-full blur-[150px]" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Label */}
        <span className="hero-animate text-xs text-white/30 tracking-[0.3em] uppercase">
          Portfolio
        </span>

        {/* Title */}
        <h1 className="hero-animate mt-6 text-5xl md:text-7xl lg:text-8xl font-light text-white leading-tight">
          Alle
          <br />
          <span className="text-emerald-500">Arbeiten</span>
        </h1>

        {/* Stats */}
        <div className="hero-animate mt-12 flex flex-wrap gap-8 md:gap-16">
          <div>
            <span className="text-4xl md:text-5xl font-light text-white">
              {allProjects.length}+
            </span>
            <p className="mt-2 text-sm text-white/40 uppercase tracking-wider">Projekte</p>
          </div>
          <div>
            <span className="text-4xl md:text-5xl font-light text-white">
              {allIndustries.length}
            </span>
            <p className="mt-2 text-sm text-white/40 uppercase tracking-wider">Branchen</p>
          </div>
          <div>
            <span className="text-4xl md:text-5xl font-light text-white">12+</span>
            <p className="mt-2 text-sm text-white/40 uppercase tracking-wider">Jahre</p>
          </div>
        </div>
      </div>
    </section>
  );
}
